// Common constants used throughout the application
export const AUTHOR_INFO = {
  NAME: 'Nikoletta Papakonstantinou',
  EMAIL: 'nikolettap396@gmail.com',
  INSTAGRAM: 'https://instagram.com/nikolettappkw?igshid=YmMyMTA2M2Y=',
  LINKEDIN: 'https://www.linkedin.com/in/nikoletta-papakonstantinou-6a402a1b6/',
};

// Common styles
export const COMMON_STYLES = {
  SECTION_PADDING: { justifyContent: 'center', paddingBottom: '10px' },
  BLACK_TEXT: { color: 'black' },
  WHITE_TEXT: { color: 'white' },
  IMAGE_PADDING: { padding: '10px' },
  VIDEO_FRAME: { position: 'relative', padding: '0 0 0 0' },
  DESCRIPTION_PADDING: { color: 'black', padding: '0 0 50px 0' },
};

// Video configuration for animations
export const VIDEO_CONFIG = {
  DEFAULT_PROPS: {
    frameBorder: '0',
    width: '100%',
    height: '360px',
    allow: 'autoplay; fullscreen; picture-in-picture',
  },
};
